import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ReactGA from "react-ga4";

import Layout from "./components/Layout";
import Analytics from "./components/Analytics";

import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import StudyAbroad from "./pages/StudyAbroad";
import SkillAssessment from "./pages/SkillAssessment";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TestimonialsPage from "./pages/TestimonialsPage";
import Terms from "./pages/Terms";

import "./styles/global.scss";

// Initialize GA once
ReactGA.initialize("G-BQ9651TNMJ"); // GA4 Measurement ID

function App() {
  return (
    <Router>
      <Analytics /> 
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/study-abroad" element={<StudyAbroad />} />
          <Route path="/skill-assessment" element={<SkillAssessment />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<Terms />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
